import React from "react";
import { HOME } from "@/constants/testIds";
import { Clock, Package, Anchor, ShieldCheck, FileWarning, AlertTriangle } from "lucide-react";

export const SmartAlerts = () => {
  const alerts = [
    { icon: Clock,        title: "ETA Updated",       body: "Mombasa arrival now 12 Jun · +1 day from port congestion.",        time: "2 min ago",   tone: "emerald" },
    { icon: Package,      title: "Container Loaded",  body: "MSCU1234567 sealed and loaded at Mersin port · weight verified.", time: "11 hr ago",   tone: "emerald" },
    { icon: Anchor,       title: "Vessel Arrived",    body: "MSC Aurelia berthed at Suez · transit corridor active.",          time: "Yesterday",   tone: "emerald" },
    { icon: ShieldCheck,  title: "Customs Released",  body: "HS code 851712 cleared · duty payable AED 4,820.",                 time: "Yesterday",   tone: "emerald" },
    { icon: FileWarning,  title: "Document Missing",  body: "Certificate of Origin not attached · request sent to supplier.",   time: "2 days ago",  tone: "amber" },
    { icon: AlertTriangle,title: "Delay Detected",    body: "Vessel speed below schedule · ETA flag raised for review.",         time: "3 days ago",  tone: "amber" },
  ];

  return (
    <section
      id="alerts"
      data-testid={HOME.alertsSection}
      className="relative py-24 md:py-32"
    >
      <div className="container-narrow">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 max-w-5xl">
          <div>
            <div className="text-[11px] font-mono uppercase tracking-[0.18em] ink-soft mb-4">
              05 — Smart Alerts
            </div>
            <h2 className="font-display text-4xl lg:text-5xl font-semibold ink leading-[1.05] text-balance">
              Calm, professional notifications — never alarming.
            </h2>
          </div>
          <p className="text-[14.5px] ink-soft max-w-md">
            Alerts are designed to inform, not interrupt. Each notification carries
            the right context to act — or to ignore — confidently.
          </p>
        </div>

        <ul className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
          {alerts.map((a) => {
            const I = a.icon;
            const toneRing = a.tone === "amber"
              ? "border-[hsla(38,92%,50%,0.25)]"
              : "border-ink-10";
            const iconStyle = a.tone === "amber"
              ? "bg-[hsla(38,92%,50%,0.10)] text-[hsl(38,92%,38%)]"
              : "bg-emerald/10 text-emerald";
            return (
              <li
                key={a.title}
                data-testid={HOME.alertCard}
                className={`rounded-2xl bg-white border ${toneRing} p-5 hover:translate-y-[-2px] transition-transform`}
              >
                <div className="flex items-start gap-3">
                  <span className={`grid h-9 w-9 place-items-center rounded-xl ${iconStyle} shrink-0`}>
                    <I className="h-4 w-4" />
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-baseline justify-between gap-2">
                      <h3 className="font-display text-[15px] font-semibold ink">{a.title}</h3>
                      <span className="text-[10.5px] font-mono ink-soft whitespace-nowrap">{a.time}</span>
                    </div>
                    <p className="mt-1.5 text-[13px] ink-soft leading-relaxed">{a.body}</p>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
